import { useEffect, useState, useCallback, useRef, useMemo } from "react";
import { GetAllEmployee, AddEmployee, UpdateEmployee, GetEmployeeById } from "../services/EmployeeService";
import { AddUser, GetUserByEmployeeId } from "../services/UserService";
import { GetUserRolesBasic } from "../services/RoleService";
import { changeUserPassword } from "../services/AuthService";
import { GetAllPost } from "../services/PostService"; // مسیر واقعی سرویس پست خودت را جایگزین کن
import { useNavigate } from "react-router-dom";
import { useLanguage } from "./LanguageContext"; // مسیر واقعی خودت

const FONT = "IRANSansWeb, Vazirmatn, sans-serif";

const TEXTS = {
    fa: {
        dir: "rtl",
        employees: "کاربران",
        manageSub: "مدیریت و پیگیری اطلاعات کاربران",
        back: "بازگشت",
        addEmployee: "افزودن کاربر",
        totalEmployees: "کل کاربران",
        active: "فعال",
        inactive: "غیرفعال",
        searchPlaceholder: "جستجو بر اساس نام، آدرس یا شماره همراه ...",
        all: "همه",
        refresh: "بارگذاری مجدد",
        employee: "کاربر",
        phone: "تلفن",
        address: "آدرس",
        role: "نقش",
        status: "وضعیت",
        actions: "عملیات",
        directManager: "مسئول مستقیم",
        noDirectManager: "—",
        viewList: "نمایش لیستی",
        viewTree: "نمایش درختی",
        retry: "تلاش مجدد",
        noEmployeeFound: "کاربری یافت نشد",
        edit: "ویرایش",
        deactivate: "غیرفعالسازی",
        activate: "فعالسازی",
        createUser: "ایجاد حساب کاربری",
        of: "از",
        employeeCountLabel: "کاربر",
        editEmployee: "ویرایش کاربر",
        addNewEmployee: "افزودن کاربر جدید",
        idLabel: "شناسه",
        enterEmployeeInfo: "اطلاعات کاربر را وارد کنید",
        firstName: "نام",
        lastName: "نام خانوادگی",
        phoneNumber: "شماره تماس",
        position: "سمت سازمانی",
        selectPosition: "انتخاب سمت",
        loadingPositions: "در حال بارگذاری سمت‌ها...",
        manager: "سرپرست مستقیم",
        noManager: "بدون سرپرست",
        cancel: "انصراف",
        saving: "در حال ذخیره...",
        save: "ذخیره",
        errorFetchEmployees: "خطا در دریافت اطلاعات کاربران",
        enterFirstName: "نام کاربر را وارد کنید",
        enterLastName: "نام خانوادگی کاربر را وارد کنید",
        enterPhone: "شماره تماس را وارد کنید",
        enterAddress: "آدرس را وارد کنید",
        enterPosition: "سمت سازمانی را انتخاب کنید",
        errorFetchPosts: "خطا در دریافت لیست سمت‌ها",
        employeeUpdated: "اطلاعات کاربر بروزرسانی شد ✓",
        employeeAdded: "کاربر جدید اضافه شد ✓",
        errorSaving: "خطا در ذخیره اطلاعات",
        employeeDeactivated: "کاربر غیرفعال شد ✓",
        employeeActivated: "کاربر فعال شد ✓",
        errorChangingStatus: "خطا در تغییر وضعیت کاربر",
        confirmStatusTitle: "تغییر وضعیت کاربر",
        confirmActivateMessage: (name) => `آیا از فعال کردن کاربر «${name}» مطمئن هستید؟`,
        confirmDeactivateMessage: (name) => `آیا از غیرفعال کردن کاربر «${name}» مطمئن هستید؟`,
        confirmYes: "بله، انجام بده",
        editUserModal: "ویرایش حساب کاربری",
        createUserModal: "ایجاد حساب کاربری",
        employeeLabel: "کاربر",
        enterUserInfo: "اطلاعات حساب کاربری را وارد کنید",
        userAlreadyExists: "حساب کاربری قبلاً ثبت شده",
        userNotRegistered: "حساب کاربری ثبت نشده",
        checking: "در حال بررسی...",
        username: "نام کاربری",
        password: "رمز عبور",
        confirmPassword: "تکرار رمز عبور",
        passwordHint: "رمز عبور باید حداقل یک حرف بزرگ و یک حرف کوچک انگلیسی داشته باشد",
        enterUsername: "نام کاربری را وارد کنید",
        enterPassword: "رمز عبور را وارد کنید",
        passwordNeedsUpper: "رمز عبور باید حداقل یک حرف بزرگ انگلیسی داشته باشد",
        passwordsNoMatch: "رمز عبور و تکرار آن یکسان نیستند",
        passwordUpdated: "رمز عبور کاربر بروزرسانی شد ✓",
        userCreated: "کاربر با موفقیت ایجاد شد ✓",
        errorSavingUser: "خطا در ذخیره اطلاعات کاربر",
        rowsPerPage: "تعداد در هر صفحه",
        prev: "قبلی",
        next: "بعدی",
        showingRange: (from, to, total) => `نمایش ${from} تا ${to} از ${total} کاربر`,
    },
    ar: {
        dir: "rtl",
        employees: "المستخدمون",
        manageSub: "إدارة وتتبع معلومات المستخدمين",
        back: "رجوع",
        addEmployee: "إضافة مستخدم",
        totalEmployees: "إجمالي المستخدمين",
        active: "نشط",
        inactive: "غير نشط",
        searchPlaceholder: "البحث بالاسم أو العنوان أو رقم الهاتف ...",
        all: "الكل",
        refresh: "تحديث",
        employee: "المستخدم",
        phone: "الهاتف",
        address: "العنوان",
        role: "الدور",
        status: "الحالة",
        actions: "العمليات",
        directManager: "المسؤول المباشر",
        noDirectManager: "—",
        viewList: "عرض القائمة",
        viewTree: "عرض شجري",
        retry: "إعادة المحاولة",
        noEmployeeFound: "لا يوجد مستخدم",
        edit: "تعديل",
        deactivate: "تعطيل",
        activate: "تفعيل",
        createUser: "إنشاء حساب مستخدم",
        of: "من",
        employeeCountLabel: "مستخدم",
        editEmployee: "تعديل المستخدم",
        addNewEmployee: "إضافة مستخدم جديد",
        idLabel: "الرمز التعريفي",
        enterEmployeeInfo: "أدخل معلومات المستخدم",
        firstName: "الاسم",
        lastName: "اسم العائلة",
        phoneNumber: "رقم الهاتف",
        position: "المنصب الوظيفي",
        selectPosition: "اختر المنصب",
        loadingPositions: "جارٍ تحميل المناصب...",
        manager: "المسؤول المباشر",
        noManager: "بدون مسؤول",
        cancel: "إلغاء",
        saving: "جارٍ الحفظ...",
        save: "حفظ",
        errorFetchEmployees: "خطأ في جلب معلومات المستخدمين",
        enterFirstName: "أدخل اسم المستخدم",
        enterLastName: "أدخل اسم عائلة المستخدم",
        enterPhone: "أدخل رقم الهاتف",
        enterAddress: "أدخل العنوان",
        enterPosition: "الرجاء اختيار المنصب الوظيفي",
        errorFetchPosts: "خطأ في جلب قائمة المناصب",
        employeeUpdated: "تم تحديث معلومات المستخدم ✓",
        employeeAdded: "تمت إضافة مستخدم جديد ✓",
        errorSaving: "خطأ في حفظ المعلومات",
        employeeDeactivated: "تم تعطيل المستخدم ✓",
        employeeActivated: "تم تفعيل المستخدم ✓",
        errorChangingStatus: "خطأ في تغيير حالة المستخدم",
        confirmStatusTitle: "تغيير حالة المستخدم",
        confirmActivateMessage: (name) => `هل أنت متأكد من تفعيل المستخدم «${name}»؟`,
        confirmDeactivateMessage: (name) => `هل أنت متأكد من إلغاء تفعيل المستخدم «${name}»؟`,
        confirmYes: "نعم، تابع",
        editUserModal: "تعديل حساب المستخدم",
        createUserModal: "إنشاء حساب مستخدم",
        employeeLabel: "المستخدم",
        enterUserInfo: "أدخل معلومات حساب المستخدم",
        userAlreadyExists: "تم تسجيل حساب المستخدم مسبقاً",
        userNotRegistered: "حساب المستخدم غير مسجل",
        checking: "جارٍ التحقق...",
        username: "اسم المستخدم",
        password: "كلمة المرور",
        confirmPassword: "تأكيد كلمة المرور",
        passwordHint: "يجب أن تحتوي كلمة المرور على حرف كبير وصغير على الأقل",
        enterUsername: "أدخل اسم المستخدم",
        enterPassword: "أدخل كلمة المرور",
        passwordNeedsUpper: "يجب أن تحتوي كلمة المرور على حرف كبير إنجليزي على الأقل",
        passwordsNoMatch: "كلمة المرور وتأكيدها غير متطابقين",
        passwordUpdated: "تم تحديث كلمة مرور المستخدم ✓",
        userCreated: "تم إنشاء المستخدم بنجاح ✓",
        errorSavingUser: "خطأ في حفظ معلومات المستخدم",
        rowsPerPage: "عدد العناصر في الصفحة",
        prev: "السابق",
        next: "التالي",
        showingRange: (from, to, total) => `عرض ${from} إلى ${to} من ${total} مستخدم`,
    },
};
const COLORS = [
    { bg: "#EDE9FF", color: "#6C3DFF" },
    { bg: "#ECFDF5", color: "#059669" },
    { bg: "#FEF2F2", color: "#DC2626" },
    { bg: "#EFF6FF", color: "#2563EB" },
    { bg: "#FDF4FF", color: "#9333EA" },
    { bg: "#FFFBEB", color: "#D97706" },
];

// رنگ هر سطح از نمودار سازمانی (سطح ریشه بنفش برند، سطوح بعدی فیروزه‌ای/آبی/خاکستری)
const ORG_LEVEL_PALETTES = [
    { grad: "linear-gradient(135deg, #6C3DFF 0%, #9B7CFF 100%)", pillBg: "rgba(255,255,255,.22)", pillText: "#fff" },
    { grad: "linear-gradient(135deg, #0D9488 0%, #2DD4BF 100%)", pillBg: "rgba(255,255,255,.24)", pillText: "#fff" },
    { grad: "linear-gradient(135deg, #0369A1 0%, #38BDF8 100%)", pillBg: "rgba(255,255,255,.24)", pillText: "#fff" },
    { grad: "linear-gradient(135deg, #475569 0%, #94A3B8 100%)", pillBg: "rgba(255,255,255,.24)", pillText: "#fff" },
];

// --- Responsive helper -------------------------------------------------
// Inline styles can't respond to @media queries by themselves, so we track
// viewport width in JS and branch layout decisions (grid -> stacked cards,
// row -> column, etc.) off of `isMobile`.
function useIsMobile(breakpoint = 720) {
    const [isMobile, setIsMobile] = useState(
        typeof window !== "undefined" ? window.innerWidth <= breakpoint : false
    );
    useEffect(() => {
        const onResize = () => setIsMobile(window.innerWidth <= breakpoint);
        window.addEventListener("resize", onResize);
        return () => window.removeEventListener("resize", onResize);
    }, [breakpoint]);
    return isMobile;
}

function Icon({ name, size = 11, color = "currentColor", style }) {
    const paths = {
        plus: (
            <>
                <line x1="12" y1="5" x2="12" y2="19" />
                <line x1="5" y1="12" x2="19" y2="12" />
            </>
        ),
        edit: (
            <>
                <path d="M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1" />
                <path d="M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z" />
            </>
        ),
        "user-off": (
            <>
                <path d="M8.18 8.189a4 4 0 1 0 5.625 5.636" />
                <path d="M6 21v-2a4 4 0 0 1 4 -4h4" />
                <line x1="3" y1="3" x2="21" y2="21" />
            </>
        ),
        "user-check": (
            <>
                <circle cx="9" cy="7" r="4" />
                <path d="M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2" />
                <path d="M16 11l2 2l4 -4" />
            </>
        ),
        "user-plus": (
            <>
                <circle cx="9" cy="7" r="4" />
                <path d="M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2" />
                <line x1="19" y1="8" x2="19" y2="14" />
                <line x1="16" y1="11" x2="22" y2="11" />
            </>
        ),
        search: (
            <>
                <circle cx="10" cy="10" r="7" />
                <line x1="21" y1="21" x2="15" y2="15" />
            </>
        ),
        refresh: (
            <>
                <path d="M20 11a8.1 8.1 0 0 0 -15.5 -2m-.5 -4v4h4" />
                <path d="M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4" />
            </>
        ),
        x: (
            <>
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
            </>
        ),
        users: (
            <>
                <circle cx="9" cy="7" r="4" />
                <path d="M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2" />
                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                <path d="M21 21v-2a4 4 0 0 0 -3 -3.85" />
            </>
        ),
        "circle-check": (
            <>
                <circle cx="12" cy="12" r="9" />
                <path d="M9 12l2 2l4 -4" />
            </>
        ),
        "circle-x": (
            <>
                <circle cx="12" cy="12" r="9" />
                <path d="M10 10l4 4m0 -4l-4 4" />
            </>
        ),
        "alert-circle": (
            <>
                <circle cx="12" cy="12" r="9" />
                <line x1="12" y1="8" x2="12" y2="12" />
                <line x1="12" y1="16" x2="12.01" y2="16" />
            </>
        ),
        "user-none": (
            <>
                <circle cx="12" cy="7" r="4" />
                <path d="M6 21v-2a6 6 0 0 1 12 0v2" />
                <line x1="3" y1="3" x2="21" y2="21" />
            </>
        ),
        "list-view": (
            <>
                <line x1="9" y1="6" x2="20" y2="6" />
                <line x1="9" y1="12" x2="20" y2="12" />
                <line x1="9" y1="18" x2="20" y2="18" />
                <line x1="4" y1="6" x2="4.01" y2="6" />
                <line x1="4" y1="12" x2="4.01" y2="12" />
                <line x1="4" y1="18" x2="4.01" y2="18" />
            </>
        ),
        "tree-view": (
            <>
                <path d="M6 4v6" />
                <path d="M6 10c0 3 2 3 2 3h8" />
                <path d="M6 10c0 3 -2 3 -2 3h-1" />
                <circle cx="6" cy="4" r="2" />
                <circle cx="16" cy="13" r="2" />
                <circle cx="3" cy="13" r="2" />
            </>
        ),
        chevron: (
            <>
                <polyline points="6 9 12 15 18 9" />
            </>
        ),
    };

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke={color}
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            style={style}
        >
            {paths[name] ?? null}
        </svg>
    );
}

function getInitials(name = "") {
    return name
        .split(" ")
        .map((w) => w[0])
        .join("")
        .slice(0, 2);
}

function Avatar({ name, index, size = 30 }) {
    const c = COLORS[index % COLORS.length];
    return (
        <div
            style={{
                width: size,
                height: size,
                borderRadius: "50%",
                background: c.bg,
                color: c.color,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 10,
                fontWeight: 600,
                flexShrink: 0,
                fontFamily: FONT,
            }}
        >
            {getInitials(name)}
        </div>
    );
}

function StatusPill({ active, t }) {
    return active ? (
        <span
            style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 5,
                padding: "2px 9px",
                borderRadius: 20,
                fontSize: 10,
                fontWeight: 500,
                background: "#ECFDF5",
                color: "#059669",
                whiteSpace: "nowrap",
            }}
        >
            <span style={{ width: 4, height: 4, borderRadius: "50%", background: "#10B981" }} />
            {t.active}
        </span>
    ) : (
        <span
            style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 5,
                padding: "2px 9px",
                borderRadius: 20,
                fontSize: 10,
                fontWeight: 500,
                background: "#F1F5F9",
                color: "#64748B",
                whiteSpace: "nowrap",
            }}
        >
            <span style={{ width: 4, height: 4, borderRadius: "50%", background: "#94A3B8" }} />
            {t.inactive}
        </span>
    );
}

/* -------------------------------------------------------------------------- */
/*  نوار صفحه‌بندی (پیجینگ)                                                    */
/* -------------------------------------------------------------------------- */
const PAGE_SIZE_OPTIONS = [10, 20, 50, 100];

function PaginationBar({ page, totalPages, pageSize, onPageChange, onPageSizeChange, rangeStart, rangeEnd, total, t }) {
    const goTo = (p) => {
        const clamped = Math.min(Math.max(1, p), totalPages);
        if (clamped !== page) onPageChange(clamped);
    };

    const pageNumbers = useMemo(() => {
        const arr = [];
        const maxButtons = 5;
        let start = Math.max(1, page - Math.floor(maxButtons / 2));
        let end = Math.min(totalPages, start + maxButtons - 1);
        start = Math.max(1, end - maxButtons + 1);
        for (let i = start; i <= end; i++) arr.push(i);
        return arr;
    }, [page, totalPages]);

    return (
        <div
            style={{
                display: "flex", alignItems: "center", justifyContent: "space-between",
                flexWrap: "wrap", gap: 12,
                padding: "12px 18px", background: "#fff",
                borderTop: "0.5px solid #E2E8F0",
                borderBottomLeftRadius: 16, borderBottomRightRadius: 16,
            }}
        >
            {/* راست: متن نمایش + انتخاب تعداد در هر صفحه */}
            <div style={{ display: "flex", alignItems: "center", gap: 14, flexWrap: "wrap" }}>
                <span style={{ fontSize: 11, color: "#94A3B8", whiteSpace: "nowrap" }}>
                    {t.showingRange(rangeStart, rangeEnd, total)}
                </span>

                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <span style={{ fontSize: 11, color: "#64748B", whiteSpace: "nowrap" }}>{t.rowsPerPage}</span>
                    <select
                        value={pageSize}
                        onChange={(e) => onPageSizeChange(Number(e.target.value))}
                        style={{
                            height: 32, borderRadius: 9, border: "0.5px solid #E2E8F0",
                            background: "#fff", color: "#0F172A", fontSize: 11.5, fontWeight: 500,
                            fontFamily: FONT, padding: "0 10px", cursor: "pointer", minWidth: 64,
                        }}
                    >
                        {PAGE_SIZE_OPTIONS.map((opt) => (
                            <option key={opt} value={opt}>{opt}</option>
                        ))}
                    </select>
                </div>
            </div>

            {/* چپ: دکمه‌های قبلی / شماره صفحه / بعدی */}
            <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                <button
                    type="button"
                    onClick={() => goTo(page - 1)}
                    disabled={page <= 1}
                    style={{
                        height: 32, padding: "0 14px", borderRadius: 9, border: "0.5px solid #E2E8F0",
                        background: "#fff", color: page <= 1 ? "#CBD5E1" : "#475569",
                        fontSize: 11, fontWeight: 500, fontFamily: FONT,
                        cursor: page <= 1 ? "not-allowed" : "pointer", whiteSpace: "nowrap",
                    }}
                >
                    {t.prev}
                </button>

                {pageNumbers.map((num) => {
                    const active = num === page;
                    return (
                        <button
                            key={num}
                            type="button"
                            onClick={() => goTo(num)}
                            style={{
                                minWidth: 32, height: 32, borderRadius: 9, border: "0.5px solid",
                                borderColor: active ? "#6C3DFF" : "#E2E8F0",
                                background: active ? "#6C3DFF" : "#fff",
                                color: active ? "#fff" : "#475569",
                                fontSize: 11.5, fontWeight: 600, fontFamily: FONT, cursor: "pointer",
                            }}
                        >
                            {num}
                        </button>
                    );
                })}

                <button
                    type="button"
                    onClick={() => goTo(page + 1)}
                    disabled={page >= totalPages}
                    style={{
                        height: 32, padding: "0 14px", borderRadius: 9, border: "0.5px solid #E2E8F0",
                        background: "#fff", color: page >= totalPages ? "#CBD5E1" : "#475569",
                        fontSize: 11, fontWeight: 500, fontFamily: FONT,
                        cursor: page >= totalPages ? "not-allowed" : "pointer", whiteSpace: "nowrap",
                    }}
                >
                    {t.next}
                </button>
            </div>
        </div>
    );
}

function OrgChartNode({ node, level, t, collapsedIds, toggleCollapse, onEdit, onDeactivate, onCreateUser }) {
    const name = `${node.firstName || ""} ${node.lastName || ""}`.trim() || "—";
    const phone = node.phoneNumber || "—";
    const isActive = node.isActive ?? node.active ?? true;
    const palette = ORG_LEVEL_PALETTES[Math.min(level, ORG_LEVEL_PALETTES.length - 1)];
    const hasChildren = node.children && node.children.length > 0;
    const isCollapsed = collapsedIds.has(node.id);

    return (
        <li>
            <div className="org-node-inner">
                <div className="org-card" style={{ background: palette.grad, direction: t.dir }}>
                    <div style={{ display: "flex", justifyContent: "center" }}>
                        <div
                            style={{
                                width: 34,
                                height: 34,
                                borderRadius: "50%",
                                background: "rgba(255,255,255,.22)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            <Icon name="user-check" size={16} color="#fff" />
                        </div>
                    </div>
                    <p style={{ fontSize: 12, fontWeight: 600, color: "#fff", margin: "8px 0 0", lineHeight: 1.3 }}>{name}</p>
                    {node.postName && (
                        <span
                            style={{
                                display: "inline-block",
                                marginTop: 6,
                                padding: "2px 10px",
                                borderRadius: 20,
                                fontSize: 10,
                                fontWeight: 500,
                                background: palette.pillBg,
                                color: palette.pillText,
                            }}
                        >
                            {node.postName}
                        </span>
                    )}
                    <p style={{ fontSize: 10, color: "rgba(255,255,255,.85)", margin: "6px 0 0" }}>{phone}</p>
                </div>

                <div className="org-card-footer" style={{ direction: t.dir }}>
                    <div style={{ display: "flex", justifyContent: "center", padding: "7px 0 6px" }}>
                        <StatusPill active={isActive} t={t} />
                    </div>
                    <div style={{ display: "flex", gap: 4, justifyContent: "center", paddingBottom: 7 }}>
                        <button onClick={() => onEdit(node)} className="icon-btn" title={t.edit} style={orgIconBtnStyle}>
                            <Icon name="edit" size={11} color="#94A3B8" />
                        </button>
                        <button
                            onClick={() => onDeactivate(node)}
                            className="deact-btn"
                            title={isActive ? t.deactivate : t.activate}
                            style={{
                                ...orgIconBtnStyle,
                                border: `0.5px solid ${isActive ? "#FEE2E2" : "#DCFCE7"}`,
                                background: isActive ? "#FEF2F2" : "#ECFDF5",
                            }}
                        >
                            <Icon name={isActive ? "user-off" : "user-check"} size={11} color={isActive ? "#DC2626" : "#059669"} />
                        </button>
                        <button onClick={() => onCreateUser(node)} className="icon-btn" title={t.createUser} style={orgIconBtnStyle}>
                            <Icon name="user-plus" size={11} color="#94A3B8" />
                        </button>
                        {hasChildren && (
                            <button
                                onClick={() => toggleCollapse(node.id)}
                                className="icon-btn"
                                title={isCollapsed ? t.viewTree : t.viewList}
                                style={orgIconBtnStyle}
                            >
                                <Icon
                                    name="chevron"
                                    size={11}
                                    color="#94A3B8"
                                    style={{ transform: isCollapsed ? "rotate(-90deg)" : "rotate(0)", transition: "transform .12s" }}
                                />
                            </button>
                        )}
                    </div>
                </div>
            </div>

            {hasChildren && !isCollapsed && (
                <ul>
                    {node.children.map((child) => (
                        <OrgChartNode
                            key={child.id}
                            node={child}
                            level={level + 1}
                            t={t}
                            collapsedIds={collapsedIds}
                            toggleCollapse={toggleCollapse}
                            onEdit={onEdit}
                            onDeactivate={onDeactivate}
                            onCreateUser={onCreateUser}
                        />
                    ))}
                </ul>
            )}
        </li>
    );
}

const orgIconBtnStyle = {
    width: 22,
    height: 22,
    borderRadius: 6,
    border: "0.5px solid #E2E8F0",
    background: "#fff",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all .12s",
    flexShrink: 0,
};

const ZOOM_MIN = 0.25;
const ZOOM_MAX = 2.5;
const clampZoom = (value) => Math.min(ZOOM_MAX, Math.max(ZOOM_MIN, value));

// Distance between two touch points, used to measure pinch gestures.
function touchDistance(touches) {
    const dx = touches[0].clientX - touches[1].clientX;
    const dy = touches[0].clientY - touches[1].clientY;
    return Math.hypot(dx, dy);
}

function OrgChart({ roots, t, collapsedIds, toggleCollapse, onEdit, onDeactivate, onCreateUser, isMobile }) {
    const wrapRef = useRef(null);
    const contentRef = useRef(null);
    const gesture = useRef({ mode: null, startDist: 0, startZoom: 1, startX: 0, startY: 0, startPanX: 0, startPanY: 0 });

    const [zoom, setZoom] = useState(1);
    const [pan, setPan] = useState({ x: 0, y: 0 });
    const [isGesturing, setIsGesturing] = useState(false);

    // On mobile, auto-fit the whole tree into view the first time (and whenever
    // the tree's contents change), so the user sees the full structure and can
    // then pinch/zoom in on the part they care about.
    const fitToScreen = useCallback(() => {
        const wrap = wrapRef.current;
        const content = contentRef.current;
        if (!wrap || !content) return;
        // Measure at zoom 1 to get the tree's natural size.
        content.style.transform = "scale(1)";
        const contentWidth = content.scrollWidth;
        const wrapWidth = wrap.clientWidth;
        const nextZoom = contentWidth > wrapWidth ? clampZoom((wrapWidth / contentWidth) * 0.94) : 1;
        setZoom(nextZoom);
        setPan({ x: 0, y: 0 });
    }, []);

    useEffect(() => {
        if (isMobile) {
            const id = requestAnimationFrame(fitToScreen);
            return () => cancelAnimationFrame(id);
        } else {
            setZoom(1);
            setPan({ x: 0, y: 0 });
        }
    }, [isMobile, roots, fitToScreen]);

    const handleTouchStart = (e) => {
        if (!isMobile) return;
        if (e.touches.length === 2) {
            gesture.current.mode = "pinch";
            gesture.current.startDist = touchDistance(e.touches);
            gesture.current.startZoom = zoom;
            setIsGesturing(true);
        } else if (e.touches.length === 1) {
            gesture.current.mode = "pan";
            gesture.current.startX = e.touches[0].clientX;
            gesture.current.startY = e.touches[0].clientY;
            gesture.current.startPanX = pan.x;
            gesture.current.startPanY = pan.y;
        }
    };

    const handleTouchMove = (e) => {
        if (!isMobile) return;
        if (gesture.current.mode === "pinch" && e.touches.length === 2) {
            e.preventDefault();
            const dist = touchDistance(e.touches);
            const ratio = dist / (gesture.current.startDist || dist);
            setZoom(clampZoom(gesture.current.startZoom * ratio));
        } else if (gesture.current.mode === "pan" && e.touches.length === 1) {
            const dx = e.touches[0].clientX - gesture.current.startX;
            const dy = e.touches[0].clientY - gesture.current.startY;
            setPan({ x: gesture.current.startPanX + dx, y: gesture.current.startPanY + dy });
        }
    };

    const handleTouchEnd = (e) => {
        if (e.touches.length === 0) {
            gesture.current.mode = null;
            setIsGesturing(false);
        } else if (e.touches.length === 1) {
            // Dropped from pinch to a single finger: restart panning from here.
            gesture.current.mode = "pan";
            gesture.current.startX = e.touches[0].clientX;
            gesture.current.startY = e.touches[0].clientY;
            gesture.current.startPanX = pan.x;
            gesture.current.startPanY = pan.y;
        }
    };

    const zoomBtnStyle = {
        width: 30,
        height: 30,
        borderRadius: 8,
        border: "0.5px solid #E2E8F0",
        background: "#fff",
        color: "#475569",
        fontSize: 15,
        fontWeight: 600,
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0 2px 8px rgba(15,23,42,.10)",
        fontFamily: FONT,
    };

    return (
        <div
            ref={wrapRef}
            style={{
                overflow: isMobile ? "hidden" : "auto",
                padding: isMobile ? "16px 4px" : "30px 20px",
                position: "relative",
                touchAction: isMobile ? "none" : "auto",
            }}
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}
        >
            {isMobile && (
                <div
                    style={{
                        position: "sticky",
                        top: 8,
                        insetInlineEnd: 8,
                        zIndex: 5,
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: 6,
                        marginBottom: 8,
                    }}
                >
                    <button onClick={() => setZoom((z) => clampZoom(z * 1.25))} style={zoomBtnStyle} title="بزرگنمایی">
                        +
                    </button>
                    <button onClick={() => setZoom((z) => clampZoom(z / 1.25))} style={zoomBtnStyle} title="کوچکنمایی">
                        −
                    </button>
                    <button onClick={fitToScreen} style={zoomBtnStyle} title="نمایش کل ساختار">
                        <Icon name="tree-view" size={13} color="#475569" />
                    </button>
                </div>
            )}
            <div
                ref={contentRef}
                style={{
                    transform: `translate(${pan.x}px, ${pan.y}px) scale(${zoom})`,
                    transformOrigin: "top center",
                    transition: isGesturing ? "none" : "transform .15s ease-out",
                    width: "fit-content",
                    margin: "0 auto",
                }}
            >
                <ul className="org-tree" style={{ direction: "ltr" }}>
                    {roots.map((root) => (
                        <OrgChartNode
                            key={root.id}
                            node={root}
                            level={0}
                            t={t}
                            collapsedIds={collapsedIds}
                            toggleCollapse={toggleCollapse}
                            onEdit={onEdit}
                            onDeactivate={onDeactivate}
                            onCreateUser={onCreateUser}
                        />
                    ))}
                </ul>
            </div>
        </div>
    );
}

function SkeletonRow({ isMobile }) {
    if (isMobile) {
        return (
            <div
                style={{
                    padding: "14px 16px",
                    borderBottom: "0.5px solid #E2E8F0",
                    display: "flex",
                    flexDirection: "column",
                    gap: 8,
                }}
            >
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                    <div
                        style={{
                            width: 34,
                            height: 34,
                            borderRadius: "50%",
                            background: "linear-gradient(90deg,#F1F5F9 25%,#E2E8F0 50%,#F1F5F9 75%)",
                            backgroundSize: "200% 100%",
                            animation: "shimmer 1.4s infinite",
                        }}
                    />
                    <div
                        style={{
                            height: 12,
                            width: 120,
                            borderRadius: 6,
                            background: "linear-gradient(90deg,#F1F5F9 25%,#E2E8F0 50%,#F1F5F9 75%)",
                            backgroundSize: "200% 100%",
                            animation: "shimmer 1.4s infinite",
                        }}
                    />
                </div>
                <div
                    style={{
                        height: 10,
                        width: "80%",
                        borderRadius: 6,
                        background: "linear-gradient(90deg,#F1F5F9 25%,#E2E8F0 50%,#F1F5F9 75%)",
                        backgroundSize: "200% 100%",
                        animation: "shimmer 1.4s infinite",
                    }}
                />
            </div>
        );
    }
    return (
        <div
            style={{
                display: "grid",
                gridTemplateColumns: "1fr 120px 140px 130px 90px 90px 120px",
                alignItems: "center",
                padding: "12px 18px",
                borderBottom: "0.5px solid #E2E8F0",
                gap: 10,
            }}
        >
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <div
                    style={{
                        width: 30,
                        height: 30,
                        borderRadius: "50%",
                        background: "linear-gradient(90deg,#F1F5F9 25%,#E2E8F0 50%,#F1F5F9 75%)",
                        backgroundSize: "200% 100%",
                        animation: "shimmer 1.4s infinite",
                        flexShrink: 0,
                    }}
                />
                <div
                    style={{
                        height: 12,
                        width: 150,
                        borderRadius: 6,
                        background: "linear-gradient(90deg,#F1F5F9 25%,#E2E8F0 50%,#F1F5F9 75%)",
                        backgroundSize: "200% 100%",
                        animation: "shimmer 1.4s infinite",
                    }}
                />
            </div>
            {[90, 130, 100, 60, 70, 60].map((w, i) => (
                <div
                    key={i}
                    style={{
                        height: 12,
                        width: w,
                        borderRadius: 6,
                        background: "linear-gradient(90deg,#F1F5F9 25%,#E2E8F0 50%,#F1F5F9 75%)",
                        backgroundSize: "200% 100%",
                        animation: "shimmer 1.4s infinite",
                    }}
                />
            ))}
        </div>
    );
}

function Toast({ message, visible }) {
    if (!visible) return null;
    return (
        <div
            style={{
                position: "fixed",
                bottom: 20,
                left: "50%",
                transform: "translateX(-50%)",
                background: "#0F172A",
                color: "#fff",
                padding: "9px 18px",
                borderRadius: 10,
                fontSize: 12,
                fontWeight: 500,
                fontFamily: FONT,
                zIndex: 1000,
                maxWidth: "92vw",
                textAlign: "center",
                boxShadow: "0 4px 16px rgba(0,0,0,.18)",
            }}
        >
            {message}
        </div>
    );
}

/* NOTE: modals no longer close when clicking the overlay/outside area.
   They only close via the explicit "cancel" button or after a successful save. */
function Modal({ open, onClose, title, sub, onSave, loading, initialData, t, postOptions = [], postsLoading, parentOptions = [] }) {
    const [form, setForm] = useState({ FirstName: "", LastName: "", PhoneNumber: "", address: "", PostId: "", ParentId: "" });

    useEffect(() => {
        if (open) {
            setForm(
                initialData
                    ? {
                        FirstName: initialData.firstName || "",
                        LastName: initialData.lastName || "",
                        PhoneNumber: initialData.phoneNumber || "",
                        address: initialData.address || "",
                        PostId: initialData.postId != null ? String(initialData.postId) : "",
                        ParentId: initialData.parentId != null ? String(initialData.parentId) : "",
                    }
                    : { FirstName: "", LastName: "", PhoneNumber: "", address: "", PostId: "", ParentId: "" }
            );
        }
    }, [open, initialData]);

    if (!open) return null;

    const fields = [
        { key: "FirstName", label: t.firstName },
        { key: "LastName", label: t.lastName },
        { key: "PhoneNumber", label: t.phoneNumber },
        { key: "address", label: t.address },
    ];

    const selectStyle = {
        width: "100%",
        height: 36,
        border: "0.5px solid #E2E8F0",
        borderRadius: 8,
        padding: "0 11px",
        fontSize: 12,
        fontFamily: FONT,
        direction: "rtl",
        outline: "none",
        color: "#0F172A",
        boxSizing: "border-box",
        background: "#fff",
    };

    // گزینه‌های سرپرست: خود کارمندی که در حال ویرایش آن هستیم از لیست حذف می‌شود
    // تا کارمند نتواند سرپرست خودش شود.
    const availableParents = parentOptions.filter(
        (e) => !initialData || e.id !== initialData.id
    );

    return (
        <div
            style={{
                position: "fixed",
                inset: 0,
                background: "rgba(15,23,42,.48)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 200,
                padding: 16,
                boxSizing: "border-box",
            }}
        >
            <div
                style={{
                    background: "#fff",
                    borderRadius: 16,
                    padding: "24px 20px",
                    width: "100%",
                    maxWidth: 320,
                    maxHeight: "90vh",
                    overflowY: "auto",
                    boxShadow: "0 20px 60px rgba(0,0,0,.15)",
                    fontFamily: FONT,
                    boxSizing: "border-box",
                }}
            >
                <p style={{ fontSize: 14, fontWeight: 600, color: "#0F172A", marginBottom: 3 }}>{title}</p>
                <p style={{ fontSize: 11, color: "#64748B", marginBottom: 18 }}>{sub}</p>

                {fields.map((f) => (
                    <div key={f.key} style={{ marginBottom: 12 }}>
                        <p style={{ fontSize: 10, fontWeight: 500, color: "#475569", marginBottom: 4 }}>{f.label}</p>
                        <input
                            value={form[f.key]}
                            onChange={(e) => setForm((prev) => ({ ...prev, [f.key]: e.target.value }))}
                            style={{
                                width: "100%",
                                height: 36,
                                border: "0.5px solid #E2E8F0",
                                borderRadius: 8,
                                padding: "0 11px",
                                fontSize: 12,
                                fontFamily: FONT,
                                direction: "rtl",
                                outline: "none",
                                color: "#0F172A",
                                boxSizing: "border-box",
                            }}
                        />
                    </div>
                ))}

                <div style={{ marginBottom: 12 }}>
                    <p style={{ fontSize: 10, fontWeight: 500, color: "#475569", marginBottom: 4 }}>{t.position}</p>
                    <select
                        value={form.PostId}
                        onChange={(e) => setForm((prev) => ({ ...prev, PostId: e.target.value }))}
                        style={selectStyle}
                        disabled={postsLoading}
                    >
                        <option value="">
                            {postsLoading ? t.loadingPositions : t.selectPosition}
                        </option>
                        {postOptions.map((p) => (
                            <option key={p.id} value={p.id}>
                                {p.name}
                            </option>
                        ))}
                    </select>
                </div>

                <div style={{ marginBottom: 12 }}>
                    <p style={{ fontSize: 10, fontWeight: 500, color: "#475569", marginBottom: 4 }}>{t.manager}</p>
                    <select
                        value={form.ParentId}
                        onChange={(e) => setForm((prev) => ({ ...prev, ParentId: e.target.value }))}
                        style={selectStyle}
                    >
                        <option value="">{t.noManager}</option>
                        {availableParents.map((e) => (
                            <option key={e.id} value={e.id}>
                                {`${e.firstName || ""} ${e.lastName || ""}`.trim()}
                            </option>
                        ))}
                    </select>
                </div>

                <div style={{ display: "flex", gap: 9, marginTop: 18 }}>
                    <button
                        onClick={onClose}
                        style={{
                            flex: 1,
                            height: 36,
                            border: "0.5px solid #E2E8F0",
                            borderRadius: 9,
                            background: "#fff",
                            fontSize: 12,
                            fontFamily: FONT,
                            cursor: "pointer",
                            color: "#64748B",
                        }}
                    >
                        {t.cancel}
                    </button>
                    <button
                        onClick={() => onSave(form)}
                        disabled={loading}
                        style={{
                            flex: 2,
                            height: 36,
                            background: "#6C3DFF",
                            border: "none",
                            borderRadius: 9,
                            color: "#fff",
                            fontSize: 12,
                            fontFamily: FONT,
                            fontWeight: 500,
                            cursor: loading ? "not-allowed" : "pointer",
                            opacity: loading ? 0.7 : 1,
                        }}
                    >
                        {loading ? t.saving : t.save}
                    </button>
                </div>
            </div>
        </div>
    );
}

function UserModal({ open, onClose, employee, onSave, loading, t }) {
    const [form, setForm] = useState({ username: "", password: "", confirmPassword: "" });
    const [existingUser, setExistingUser] = useState(null);
    const [checkingUser, setCheckingUser] = useState(false);

    useEffect(() => {
        if (!open || !employee) return;
        setForm({ username: "", password: "", confirmPassword: "" });
        setExistingUser(null);
        setCheckingUser(true);

        GetUserByEmployeeId(employee.id)
            .then((res) => {
                const user = res.data?.data ?? res.data ?? null;
                if (user && user.id) {
                    setExistingUser(user);
                    setForm({
                        username: user.userName || user.username || "",
                        password: "",
                        confirmPassword: "",
                    });
                }
            })
            .catch(() => { })
            .finally(() => setCheckingUser(false));
    }, [open, employee]);

    if (!open) return null;

    const fields = [
        { key: "username", label: t.username, type: "text" },
        { key: "password", label: t.password, type: "password" },
        { key: "confirmPassword", label: t.confirmPassword, type: "password" },
    ];

    return (
        <div
            style={{
                position: "fixed",
                inset: 0,
                background: "rgba(15,23,42,.48)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 200,
                padding: 16,
                boxSizing: "border-box",
            }}
        >
            <div
                style={{
                    background: "#fff",
                    borderRadius: 16,
                    padding: "24px 20px",
                    width: "100%",
                    maxWidth: 320,
                    maxHeight: "90vh",
                    overflowY: "auto",
                    boxShadow: "0 20px 60px rgba(0,0,0,.15)",
                    fontFamily: FONT,
                    boxSizing: "border-box",
                }}
            >
                <p style={{ fontSize: 14, fontWeight: 600, color: "#0F172A", marginBottom: 3 }}>
                    {existingUser ? t.editUserModal : t.createUserModal}
                </p>
                <p style={{ fontSize: 11, color: "#64748B", marginBottom: existingUser ? 7 : 18 }}>
                    {employee
                        ? `${t.employeeLabel}: ${(employee.firstName || "")} ${(employee.lastName || "")}`.trim()
                        : t.enterUserInfo}
                </p>

                {!checkingUser && (
                    <div
                        style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: 5,
                            padding: "3px 9px",
                            borderRadius: 20,
                            fontSize: 10,
                            fontWeight: 500,
                            marginBottom: 16,
                            background: existingUser ? "#ECFDF5" : "#F1F5F9",
                            color: existingUser ? "#059669" : "#64748B",
                        }}
                    >
                        <span
                            style={{
                                width: 4,
                                height: 4,
                                borderRadius: "50%",
                                background: existingUser ? "#10B981" : "#94A3B8",
                            }}
                        />
                        {existingUser ? t.userAlreadyExists : t.userNotRegistered}
                    </div>
                )}

                {checkingUser ? (
                    <div style={{ textAlign: "center", padding: "18px 0", color: "#94A3B8", fontSize: 12 }}>
                        {t.checking}
                    </div>
                ) : (
                    fields.map((f) => (
                        <div key={f.key} style={{ marginBottom: 12 }}>
                            <p style={{ fontSize: 10, fontWeight: 500, color: "#475569", marginBottom: 4 }}>{f.label}</p>
                            <input
                                type={f.type}
                                value={form[f.key]}
                                onChange={(e) => setForm((prev) => ({ ...prev, [f.key]: e.target.value }))}
                                style={{
                                    width: "100%",
                                    height: 36,
                                    border: "0.5px solid #E2E8F0",
                                    borderRadius: 8,
                                    padding: "0 11px",
                                    fontSize: 12,
                                    fontFamily: FONT,
                                    direction: "rtl",
                                    outline: "none",
                                    color: "#0F172A",
                                    boxSizing: "border-box",
                                }}
                            />
                            {f.key === "password" && form.password && !/(?=.*[A-Z])(?=.*[a-z])/.test(form.password) && (
                                <p style={{ fontSize: 9, color: "#DC2626", marginTop: 3, marginBottom: 0 }}>
                                    {t.passwordHint}
                                </p>
                            )}
                        </div>
                    ))
                )}

                <div style={{ display: "flex", gap: 9, marginTop: 18 }}>
                    <button
                        onClick={onClose}
                        style={{
                            flex: 1,
                            height: 36,
                            border: "0.5px solid #E2E8F0",
                            borderRadius: 9,
                            background: "#fff",
                            fontSize: 12,
                            fontFamily: FONT,
                            cursor: "pointer",
                            color: "#64748B",
                        }}
                    >
                        {t.cancel}
                    </button>
                    <button
                        onClick={() => onSave(form, existingUser)}
                        disabled={loading || checkingUser}
                        style={{
                            flex: 2,
                            height: 36,
                            background: "#6C3DFF",
                            border: "none",
                            borderRadius: 9,
                            color: "#fff",
                            fontSize: 12,
                            fontFamily: FONT,
                            fontWeight: 500,
                            cursor: loading || checkingUser ? "not-allowed" : "pointer",
                            opacity: loading || checkingUser ? 0.7 : 1,
                        }}
                    >
                        {loading ? t.saving : t.save}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default function EmployeeView() {
    const navigate = useNavigate();
    const { lang } = useLanguage();
    const t = TEXTS[lang] || TEXTS.fa;
    const isMobile = useIsMobile();

    const [employees, setEmployees] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [search, setSearch] = useState("");
    const [filterStatus, setFilterStatus] = useState("all");
    const [modalOpen, setModalOpen] = useState(false);
    const [editEmployee, setEditEmployee] = useState(null);
    const [saving, setSaving] = useState(false);
    const [toast, setToast] = useState({ visible: false, message: "" });
    const [userModalOpen, setUserModalOpen] = useState(false);
    const [userModalEmployee, setUserModalEmployee] = useState(null);
    const [savingUser, setSavingUser] = useState(false);
    const [posts, setPosts] = useState([]);
    const [postsLoading, setPostsLoading] = useState(true);
    const [viewMode, setViewMode] = useState("list"); // "list" | "tree"
    const [collapsedIds, setCollapsedIds] = useState(() => new Set());
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [employeeRoles, setEmployeeRoles] = useState({}); // { [employeeId]: "نقش۱، نقش۲" }
    const [confirmDeactivate, setConfirmDeactivate] = useState(null); // کاربری که منتظر تایید تغییر وضعیت است

    const toggleCollapse = (id) => {
        setCollapsedIds((prev) => {
            const next = new Set(prev);
            if (next.has(id)) next.delete(id);
            else next.add(id);
            return next;
        });
    };

    const showToast = (message) => {
        setToast({ visible: true, message });
        setTimeout(() => setToast({ visible: false, message: "" }), 2800);
    };
    const extractServerErrorMessage = (err) => {
        const data = err?.response?.data;
        if (typeof data === "string" && data.trim()) return data.trim();
        if (data && typeof data === "object") {
            return data.message || data.Message || data.title || data.error || null;
        }
        return null;
    };
    const fetchEmployees = useCallback(async () => {
        try {
            setLoading(true);
            setError(null);
            const res = await GetAllEmployee();
            const data = res.data?.data ?? res.data ?? [];
            setEmployees(Array.isArray(data) ? data : []);
        } catch (err) {
            setError(extractServerErrorMessage(err) || t.errorFetchEmployees);
        } finally {
            setLoading(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [lang]);

    useEffect(() => {
        fetchEmployees();
    }, [fetchEmployees]);

    // نقش هر کارمند از طریق حساب کاربری متصل به او خوانده می‌شود
    // (با اندپوینت GetUserRolesBasic که برای همه‌ی کاربران لاگین‌شده باز است).
    // اگر برای یک کارمند خاص حساب کاربری وجود نداشته باشد یا خطایی رخ دهد،
    // به‌سادگی از نمایش نقش او صرف‌نظر می‌شود و بقیه‌ی صفحه بدون مشکل کار می‌کند.
    useEffect(() => {
        if (!employees.length) return;
        let cancelled = false;

        const getUserId = (user) =>
            user?.id ?? user?.Id ?? user?.userId ?? user?.UserId ?? null;

        const getRoleName = (r) => {
            if (typeof r === "string") return r;
            return r?.name ?? r?.Name ?? r?.roleName ?? r?.RoleName ?? r?.title ?? r?.Title ?? null;
        };

        (async () => {
            const results = await Promise.allSettled(
                employees.map(async (emp) => {
                    const userRes = await GetUserByEmployeeId(emp.id);
                    const user = userRes.data?.data ?? userRes.data ?? null;
                    const userId = getUserId(user);
                    if (!userId) return null;

                    const rolesRes = await GetUserRolesBasic(userId);
                    const roles = rolesRes.data?.data ?? rolesRes.data ?? [];
                    const roleNames = Array.isArray(roles)
                        ? roles.map(getRoleName).filter(Boolean)
                        : [];
                    if (!roleNames.length) {
                        // برای اشکال‌زدایی: اگر روی صفحه همه چیز خط‌تیره ماند، این لاگ را
                        // در کنسول مرورگر چک کنید تا شکل واقعی پاسخ سرور را ببینید.
                        console.log("[role-column] no role names parsed for employee", emp.id, { user, roles });
                        return null;
                    }

                    return { employeeId: emp.id, role: roleNames.join("، ") };
                })
            );

            if (cancelled) return;
            setEmployeeRoles((prev) => {
                const next = { ...prev };
                results.forEach((r) => {
                    if (r.status === "fulfilled" && r.value) {
                        next[r.value.employeeId] = r.value.role;
                    } else if (r.status === "rejected") {
                        console.log("[role-column] fetch failed", r.reason);
                    }
                });
                return next;
            });
        })();

        return () => {

            cancelled = true;
        };
    }, [employees]);

    useEffect(() => {
        let mounted = true;
        setPostsLoading(true);
        GetAllPost()
            .then((res) => {
                if (!mounted) return;
                const data = res.data?.data ?? res.data ?? [];
                setPosts(Array.isArray(data) ? data : []);
            })
            .catch((err) => {
                if (mounted) showToast(extractServerErrorMessage(err) || t.errorFetchPosts);
            })
            .finally(() => {
                if (mounted) setPostsLoading(false);
            });
        return () => {
            mounted = false;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [lang]);

    const handleSave = async (form) => {
        if (!form.FirstName?.trim()) { showToast(t.enterFirstName); return; }
        if (!form.LastName?.trim()) { showToast(t.enterLastName); return; }
        if (!form.PhoneNumber?.trim()) { showToast(t.enterPhone); return; }
        if (!form.address?.trim()) { showToast(t.enterAddress); return; }
        if (!form.PostId) { showToast(t.enterPosition); return; }
        try {
            setSaving(true);
            const model = {
                FirstName: form.FirstName,
                LastName: form.LastName,
                PhoneNumber: form.PhoneNumber,
                address: form.address,
                isActive: true,
                PostId: Number(form.PostId),
                ParentId: form.ParentId ? Number(form.ParentId) : null,
            };
            if (editEmployee) {
                await UpdateEmployee({ ...model, id: editEmployee.id });
                showToast(t.employeeUpdated);
            } else {
                await AddEmployee(model);
                showToast(t.employeeAdded);
            }
            setModalOpen(false);
            setEditEmployee(null);
            await fetchEmployees();
        } catch (err) {
            showToast(extractServerErrorMessage(err) || t.errorSaving);
        } finally {
            setSaving(false);
        }
    };

    const handleEdit = async (employee) => {
        try {
            const res = await GetEmployeeById(employee.id);
            const detail = res.data?.data ?? res.data ?? employee;
            setEditEmployee(detail);
            setModalOpen(true);
        } catch (err) {
            showToast(extractServerErrorMessage(err) || t.errorFetchEmployees);
            setEditEmployee(employee);
            setModalOpen(true);
        }
    };

    // با کلیک روی دکمه فعال/غیرفعال، فقط دیالوگ تایید باز می‌شود؛ تغییر واقعی بعد از تایید کاربر انجام می‌گیرد
    const requestDeactivate = (employee) => {
        setConfirmDeactivate(employee);
    };

    const closeConfirmDeactivate = () => setConfirmDeactivate(null);

    const confirmDeactivateStatus = async () => {
        if (!confirmDeactivate) return;
        const employee = confirmDeactivate;
        setConfirmDeactivate(null);
        await performDeactivate(employee);
    };

    const performDeactivate = async (employee) => {
        try {
            const model = {
                id: employee.id,
                FirstName: employee.firstName,
                LastName: employee.lastName,
                PhoneNumber: employee.phoneNumber,
                address: employee.address,
                isActive: !employee.isActive,
                PostId: employee.postId,
                ParentId: employee.parentId ?? null,
            };
            await UpdateEmployee(model);
            showToast(employee.isActive ? t.employeeDeactivated : t.employeeActivated);
            await fetchEmployees();
        } catch (err) {
            showToast(extractServerErrorMessage(err) || t.errorChangingStatus);
        }
    };

    const handleOpenUserModal = (employee) => {
        setUserModalEmployee(employee);
        setUserModalOpen(true);
    };

    const handleSaveUser = async (form, existingUser) => {
        if (!form.username?.trim()) { showToast(t.enterUsername); return; }
        if (!form.password?.trim()) { showToast(t.enterPassword); return; }
        if (!/[A-Z]/.test(form.password)) { showToast(t.passwordNeedsUpper); return; }
        if (form.password !== form.confirmPassword) { showToast(t.passwordsNoMatch); return; }

        try {
            setSavingUser(true);
            if (existingUser) {
                await changeUserPassword(existingUser.id, form.password);
                showToast(t.passwordUpdated);
            } else {
                await AddUser({
                    username: form.username,
                    password: form.password,
                    employeeId: userModalEmployee.id,
                });
                showToast(t.userCreated);
            }
            setUserModalOpen(false);
            setUserModalEmployee(null);
        } catch (err) {
            showToast(extractServerErrorMessage(err) || t.errorSavingUser);
        } finally {
            setSavingUser(false);
        }
    };

    const openAdd = () => {
        setEditEmployee(null);
        setModalOpen(true);
    };

    const filtered = employees.filter((s) => {
        const name = `${s.firstName || ""} ${s.lastName || ""}`.trim();
        const phone = s.phoneNumber || "";
        const address = s.address || "";
        const matchSearch =
            !search ||
            name.includes(search) ||
            phone.includes(search) ||
            address.includes(search);
        const isActive = s.isActive ?? s.active ?? true;
        const matchStatus =
            filterStatus === "all" ||
            (filterStatus === "active" && isActive) ||
            (filterStatus === "inactive" && !isActive);
        return matchSearch && matchStatus;
    });

    const totalActive = employees.filter((s) => s.isActive ?? s.active ?? true).length;
    const totalInactive = employees.length - totalActive;

    // نگاشت شناسه به نام کامل، برای نمایش «مسئول مستقیم» حتی وقتی parentName
    // از بک‌اند نیامده باشد.
    const nameById = new Map(
        employees.map((e) => [e.id, `${e.firstName || ""} ${e.lastName || ""}`.trim()])
    );
    const getManagerName = (employee) =>
        employee.parentName ||
        (employee.parentId != null ? nameById.get(employee.parentId) : null) ||
        t.noDirectManager;

    // ساخت درخت تودرتو (بدون تخت‌سازی) برای نمایش گرافیکی نمودار سازمانی
    const buildTree = (list) => {
        const byId = new Map(list.map((e) => [e.id, { ...e, children: [] }]));
        const roots = [];
        byId.forEach((node) => {
            if (node.parentId != null && byId.has(node.parentId)) {
                byId.get(node.parentId).children.push(node);
            } else {
                roots.push(node);
            }
        });
        return roots;
    };

    const displayRows =
        viewMode === "tree"
            ? []
            : filtered.map((employee) => ({ employee, level: 0, hasChildren: false }));

    const treeRoots = viewMode === "tree" ? buildTree(filtered) : [];

    // پیجینگ فقط روی نمای فهرستی (جدول) اعمال می‌شود
    const totalItems = displayRows.length;
    const totalPages = Math.max(1, Math.ceil(totalItems / pageSize));
    const pagedDisplayRows = displayRows.slice((page - 1) * pageSize, page * pageSize);
    const pageRangeStart = totalItems === 0 ? 0 : (page - 1) * pageSize + 1;
    const pageRangeEnd = Math.min(page * pageSize, totalItems);

    useEffect(() => {
        setPage(1);
    }, [search, filterStatus, pageSize, viewMode]);

    useEffect(() => {
        if (page > totalPages) setPage(totalPages);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [totalPages]);

    const statCards = [
        { label: t.totalEmployees, value: employees.length, color: "#6C3DFF", bg: "#EDE9FF", icon: "users" },
        { label: t.active, value: totalActive, color: "#059669", bg: "#ECFDF5", icon: "circle-check" },
        { label: t.inactive, value: totalInactive, color: "#DC2626", bg: "#FEF2F2", icon: "circle-x" },
    ];

    const cols =
        "minmax(190px, 2.4fr) minmax(80px, 0.95fr) minmax(95px, 1.1fr) minmax(95px, 1.1fr) minmax(100px, 1.2fr) minmax(75px, 0.9fr) minmax(70px, 0.85fr) minmax(100px, 1.15fr)";
    const thStyle = { fontSize: 10, fontWeight: 500, color: "#94A3B8", textAlign: "right" };

    const iconBtnStyle = {
        width: 26,
        height: 26,
        borderRadius: 7,
        border: "0.5px solid #E2E8F0",
        background: "#fff",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transition: "all .12s",
        flexShrink: 0,
    };

    return (
        <div
            style={{
                fontFamily: FONT,
                direction: t.dir,
                background: "#F8FAFC",
                minHeight: "100vh",
            }}
        >
            <style>{`
                @keyframes shimmer { 0%{background-position:200% 0} 100%{background-position:-200% 0} }
                .employee-row:hover { background: #FAFBFF !important; }
                .icon-btn:hover { border-color: #6C3DFF !important; background: #EDE9FF !important; }
                .deact-btn:hover { opacity: 0.8; }
                .filter-chip.active-chip { background: #6C3DFF !important; color: #fff !important; border-color: #6C3DFF !important; }
                input:focus { border-color: #6C3DFF !important; box-shadow: 0 0 0 3px rgba(108,61,255,.1); }
                * { box-sizing: border-box; }

                /* --- Graphical org chart (hierarchy view) --- */
                .org-tree, .org-tree ul { display: table; margin: 0 auto; padding: 0; }
                .org-tree, .org-tree ul, .org-tree li { list-style: none; position: relative; }
                .org-tree li { display: table-cell; vertical-align: top; text-align: center; padding-top: 36px; }
                .org-tree > li { padding-top: 0; }
                .org-tree li::before, .org-tree li::after {
                    content: ""; position: absolute; top: 0; left: 0; width: 50%; height: 36px;
                    border-top: 2px solid #94A3B8;
                }
                .org-tree li::after { left: 50%; border-left: 2px solid #94A3B8; border-top-left-radius: 0; }
                .org-tree li:first-child::before { border: none; }
                .org-tree li:last-child::after { border: none; }
                .org-tree li:first-child::after { border-top-left-radius: 8px; }
                .org-tree li:last-child::before { border-right: 2px solid #94A3B8; border-top-right-radius: 8px; }
                .org-tree li:only-child::before, .org-tree li:only-child::after { display: none; }
                .org-tree li:only-child { padding-top: 0; }
                .org-tree > li::before, .org-tree > li::after { display: none; }
                .org-tree ul::before {
                    content: ""; position: absolute; top: 0; left: 50%; width: 0; height: 36px;
                    border-left: 2px solid #94A3B8;
                }
                .org-node-inner {
                    display: inline-flex; flex-direction: column; width: 172px; margin: 0 10px;
                    border-radius: 14px; overflow: hidden; box-shadow: 0 4px 14px rgba(15,23,42,.08);
                    border: 0.5px solid #E2E8F0; background: #fff; transition: box-shadow .15s, transform .15s;
                }
                .org-node-inner:hover { box-shadow: 0 8px 22px rgba(15,23,42,.14); transform: translateY(-1px); }
                .org-card { padding: 14px 10px 12px; text-align: center; }
                .org-card-footer { background: #fff; position: relative; }
                @media (max-width: 640px) {
                    .org-node-inner { width: 138px; margin: 0 6px; }
                }
            `}</style>

            {/* Header box: gradient banner, edge-to-edge (no horizontal padding here) */}
            <div
                style={{
                    background: "linear-gradient(135deg, #6C3DFF 0%, #9B7CFF 100%)",
                    padding: isMobile ? "16px 16px 42px" : "18px 22px 46px",
                    display: "flex",
                    flexDirection: isMobile ? "column" : "row",
                    alignItems: isMobile ? "stretch" : "center",
                    justifyContent: "space-between",
                    gap: isMobile ? 14 : 0,
                    boxShadow: "0 6px 18px rgba(108,61,255,.18)",
                }}
            >
                <div>
                    <h1 style={{ fontSize: 16, fontWeight: 600, color: "#fff", margin: 0 }}>{t.employees}</h1>
                    <p style={{ fontSize: 11, color: "rgba(255,255,255,.85)", margin: "3px 0 0" }}>{t.manageSub}</p>
                </div>
                <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                    <button
                        onClick={() => navigate("/dashboard")}
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: 5,
                            flex: isMobile ? 1 : "initial",
                            background: "rgba(255,255,255,.15)",
                            border: "0.5px solid rgba(255,255,255,.35)",
                            borderRadius: 9,
                            padding: "8px 14px",
                            fontSize: 12,
                            cursor: "pointer",
                            color: "#fff",
                            fontFamily: FONT,
                        }}
                    >
                        {t.back}
                    </button>
                    <button
                        onClick={openAdd}
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: 6,
                            flex: isMobile ? 1 : "initial",
                            background: "#fff",
                            color: "#6C3DFF",
                            border: "none",
                            borderRadius: 9,
                            padding: "8px 16px",
                            fontSize: 12,
                            fontWeight: 600,
                            cursor: "pointer",
                            fontFamily: FONT,
                            whiteSpace: "nowrap",
                        }}
                    >
                        <Icon name="plus" size={12} color="#6C3DFF" />
                        {t.addEmployee}
                    </button>
                </div>
            </div>

            {/* Everything below the header gets horizontal padding.
                Extra bottom padding on mobile keeps the last row from being
                hidden behind the app's fixed bottom navigation bar. */}
            <div style={{ padding: isMobile ? "0 12px 96px" : "0 20px 20px" }}>

                {/* Stats card: floats between the purple header box above and the
                search/table box below. Stacks vertically on mobile so the
                numbers/labels don't get squeezed. */}
                <div
                    style={{
                        background: "#fff",
                        border: "0.5px solid #E2E8F0",
                        borderRadius: 14,
                        padding: isMobile ? "14px 16px" : "16px 26px",
                        margin: isMobile ? "-26px 0 12px" : "-30px 0 12px",
                        position: "relative",
                        zIndex: 2,
                        display: "flex",
                        flexDirection: isMobile ? "column" : "row",
                        alignItems: isMobile ? "stretch" : "center",
                        justifyContent: "space-around",
                        boxShadow: "0 8px 20px rgba(15,23,42,.08)",
                        gap: isMobile ? 10 : 0,
                    }}
                >
                    {statCards.map((s, i) => (
                        <div
                            key={s.label}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 16,
                                flex: 1,
                                justifyContent: isMobile ? "flex-start" : "center",
                                borderRight: !isMobile && i < statCards.length - 1 ? "0.5px solid #F1F5F9" : "none",
                                borderBottom: isMobile && i < statCards.length - 1 ? "0.5px solid #F1F5F9" : "none",
                                paddingBottom: isMobile && i < statCards.length - 1 ? 10 : 0,
                            }}
                        >
                            <span style={{ fontSize: 20, fontWeight: 700, color: "#0F172A" }}>
                                {loading ? "—" : s.value}
                            </span>
                            <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                                <div
                                    style={{
                                        width: 30,
                                        height: 30,
                                        borderRadius: 9,
                                        background: s.bg,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        flexShrink: 0,
                                    }}
                                >
                                    <Icon name={s.icon} size={14} color={s.color} />
                                </div>
                                <p style={{ fontSize: 11, color: "#64748B", margin: 0, whiteSpace: "nowrap" }}>{s.label}</p>
                            </div>
                        </div>
                    ))}
                </div>

                <div
                    style={{
                        display: "flex",
                        flexDirection: isMobile ? "column" : "row",
                        alignItems: isMobile ? "stretch" : "center",
                        gap: 9,
                        marginBottom: 12,
                    }}
                >
                    <div
                        style={{
                            flex: 1,
                            display: "flex",
                            alignItems: "center",
                            gap: 7,
                            background: "#fff",
                            border: "0.5px solid #E2E8F0",
                            borderRadius: 9,
                            padding: "0 12px",
                            height: 36,
                            minWidth: 0,
                        }}
                    >
                        <Icon name="search" size={13} color="#94A3B8" />
                        <input
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            placeholder={t.searchPlaceholder}
                            style={{
                                border: "none",
                                outline: "none",
                                fontSize: 12,
                                fontFamily: FONT,
                                direction: "rtl",
                                flex: 1,
                                minWidth: 0,
                                color: "#0F172A",
                                background: "transparent",
                            }}
                        />
                        {search && (
                            <button
                                onClick={() => setSearch("")}
                                style={{ border: "none", background: "none", cursor: "pointer", display: "flex", alignItems: "center" }}
                            >
                                <Icon name="x" size={12} color="#94A3B8" />
                            </button>
                        )}
                    </div>

                    <div style={{ display: "flex", gap: 9, flexWrap: "wrap" }}>
                        {["all", "active", "inactive"].map((s) => (
                            <button
                                key={s}
                                onClick={() => setFilterStatus(s)}
                                className={`filter-chip ${filterStatus === s ? "active-chip" : ""}`}
                                style={{
                                    height: 36,
                                    flex: isMobile ? 1 : "initial",
                                    padding: "0 14px",
                                    background: "#fff",
                                    border: "0.5px solid #E2E8F0",
                                    borderRadius: 9,
                                    fontSize: 11,
                                    fontFamily: FONT,
                                    cursor: "pointer",
                                    color: "#64748B",
                                    transition: "all .15s",
                                    whiteSpace: "nowrap",
                                }}
                            >
                                {s === "all" ? t.all : s === "active" ? t.active : t.inactive}
                            </button>
                        ))}

                        <div
                            style={{
                                display: "flex",
                                border: "0.5px solid #E2E8F0",
                                borderRadius: 9,
                                overflow: "hidden",
                                flexShrink: 0,
                            }}
                        >
                            <button
                                onClick={() => setViewMode("list")}
                                title={t.viewList}
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 6,
                                    height: 36,
                                    padding: "0 12px",
                                    border: "none",
                                    background: viewMode === "list" ? "#6C3DFF" : "#fff",
                                    cursor: "pointer",
                                    fontFamily: FONT,
                                    fontSize: 11,
                                    color: viewMode === "list" ? "#fff" : "#64748B",
                                    whiteSpace: "nowrap",
                                }}
                            >
                                <Icon name="list-view" size={14} color={viewMode === "list" ? "#fff" : "#64748B"} />
                                {t.viewList}
                            </button>
                            <button
                                onClick={() => setViewMode("tree")}
                                title={t.viewTree}
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 6,
                                    height: 36,
                                    padding: "0 12px",
                                    border: "none",
                                    borderRight: "0.5px solid #E2E8F0",
                                    background: viewMode === "tree" ? "#6C3DFF" : "#fff",
                                    cursor: "pointer",
                                    fontFamily: FONT,
                                    fontSize: 11,
                                    color: viewMode === "tree" ? "#fff" : "#64748B",
                                    whiteSpace: "nowrap",
                                }}
                            >
                                <Icon name="tree-view" size={14} color={viewMode === "tree" ? "#fff" : "#64748B"} />
                                {t.viewTree}
                            </button>
                        </div>

                        <button
                            onClick={fetchEmployees}
                            style={{
                                width: 36,
                                height: 36,
                                background: "#fff",
                                border: "0.5px solid #E2E8F0",
                                borderRadius: 9,
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                flexShrink: 0,
                            }}
                            title={t.refresh}
                        >
                            <Icon name="refresh" size={14} color="#64748B" />
                        </button>
                    </div>
                </div>

                <div style={{ background: "#fff", border: "0.5px solid #E2E8F0", borderRadius: 16, overflow: "hidden", display: "flex", flexDirection: "column" }}>
                    {!isMobile && viewMode === "list" && (
                        <div
                            style={{
                                display: "grid",
                                gridTemplateColumns: cols,
                                alignItems: "center",
                                padding: "11px 18px",
                                background: "#FAFAFA",
                                borderBottom: "0.5px solid #E2E8F0",
                                gap: 10,
                                flexShrink: 0,
                            }}
                        >
                            <div style={thStyle}>{t.employee}</div>
                            <div style={thStyle}>{t.position}</div>
                            <div style={thStyle}>{t.directManager}</div>
                            <div style={thStyle}>{t.phone}</div>
                            <div style={thStyle}>{t.address}</div>
                            <div style={{ ...thStyle, textAlign: "center" }}>{t.role}</div>
                            <div style={{ ...thStyle, textAlign: "center" }}>{t.status}</div>
                            <div style={{ ...thStyle, textAlign: "center" }}>{t.actions}</div>
                        </div>
                    )}

                    {/* بدنه جدول؛ فقط وقتی نمای فهرستی است اسکرول عمودی مستقل دارد تا کل صفحه اسکرول نخورد */}
                    <div style={viewMode === "list" ? { overflowY: "auto", maxHeight: 900 } : undefined}>
                    {loading ? (
                        Array.from({ length: 5 }).map((_, i) => <SkeletonRow key={i} isMobile={isMobile} />)
                    ) : error ? (
                        <div style={{ textAlign: "center", padding: "36px 16px", color: "#DC2626", fontSize: 12 }}>
                            <div style={{ display: "flex", justifyContent: "center", marginBottom: 9 }}>
                                <Icon name="alert-circle" size={28} color="#DC2626" />
                            </div>
                            {error}
                            <br />
                            <button
                                onClick={fetchEmployees}
                                style={{
                                    marginTop: 11,
                                    padding: "7px 16px",
                                    background: "#6C3DFF",
                                    color: "#fff",
                                    border: "none",
                                    borderRadius: 8,
                                    cursor: "pointer",
                                    fontFamily: FONT,
                                    fontSize: 11,
                                }}
                            >
                                {t.retry}
                            </button>
                        </div>
                    ) : filtered.length === 0 ? (
                        <div style={{ textAlign: "center", padding: "44px 16px", color: "#94A3B8" }}>
                            <div style={{ display: "flex", justifyContent: "center", marginBottom: 11 }}>
                                <Icon name="user-none" size={32} color="#94A3B8" />
                            </div>
                            <p style={{ fontSize: 12 }}>{t.noEmployeeFound}</p>
                        </div>
                    ) : viewMode === "tree" ? (
                        // --- Hierarchy view: graphical org chart with connecting lines ---
                        <OrgChart
                            roots={treeRoots}
                            t={t}
                            collapsedIds={collapsedIds}
                            toggleCollapse={toggleCollapse}
                            onEdit={handleEdit}
                            onDeactivate={requestDeactivate}
                            onCreateUser={handleOpenUserModal}
                            isMobile={isMobile}
                        />
                    ) : isMobile ? (
                        // --- Mobile: stacked card layout instead of a fixed-width grid ---
                        pagedDisplayRows.map(({ employee, level, hasChildren }, i) => {
                            const name = `${employee.firstName || ""} ${employee.lastName || ""}`.trim() || "—";
                            const phone = employee.phoneNumber || "—";
                            const address = employee.address || "—";
                            const isActive = employee.isActive ?? employee.active ?? true;
                            const isCollapsed = collapsedIds.has(employee.id);
                            const managerName = getManagerName(employee);
                            return (
                                <div
                                    key={employee.id ?? i}
                                    style={{
                                        padding: "14px 16px",
                                        borderBottom: i < pagedDisplayRows.length - 1 ? "0.5px solid #F1F5F9" : "none",
                                        background: i % 2 === 1 ? "#EEF1F7" : "#fff",
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: 10,
                                        marginInlineStart: viewMode === "tree" ? level * 16 : 0,
                                    }}
                                >
                                    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                                        {viewMode === "tree" && (
                                            hasChildren ? (
                                                <button
                                                    onClick={() => toggleCollapse(employee.id)}
                                                    style={{
                                                        width: 18,
                                                        height: 18,
                                                        border: "none",
                                                        background: "none",
                                                        cursor: "pointer",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        flexShrink: 0,
                                                        padding: 0,
                                                    }}
                                                >
                                                    <Icon
                                                        name="chevron"
                                                        size={12}
                                                        color="#64748B"
                                                        style={{ transform: isCollapsed ? "rotate(-90deg)" : "rotate(0)", transition: "transform .12s" }}
                                                    />
                                                </button>
                                            ) : (
                                                <span style={{ width: 18, flexShrink: 0 }} />
                                            )
                                        )}
                                        <Avatar name={name} index={i} size={34} />
                                        <div style={{ flex: 1, minWidth: 0 }}>
                                            <p style={{ fontSize: 13, fontWeight: 500, color: "#0F172A", margin: 0 }}>{name}</p>
                                            <p style={{ fontSize: 11, color: "#94A3B8", margin: "2px 0 0" }}>{phone}</p>
                                        </div>
                                        <StatusPill active={isActive} t={t} />
                                    </div>

                                    {employee.postName && (
                                        <p style={{ fontSize: 11, color: "#94A3B8", margin: 0 }}>
                                            {t.position}: <span style={{ color: "#6C3DFF" }}>{employee.postName}</span>
                                        </p>
                                    )}
                                    <p style={{ fontSize: 11, color: "#94A3B8", margin: 0 }}>
                                        {t.directManager}: <span style={{ color: "#475569" }}>{managerName}</span>
                                    </p>
                                    {employeeRoles[employee.id] && (
                                        <p style={{ fontSize: 11, color: "#94A3B8", margin: 0 }}>
                                            {t.role}: <span style={{ color: "#475569" }}>{employeeRoles[employee.id]}</span>
                                        </p>
                                    )}
                                    <p style={{ fontSize: 11, color: "#475569", margin: 0 }}>{address}</p>

                                    <div style={{ display: "flex", gap: 8 }}>
                                        <button
                                            onClick={() => handleEdit(employee)}
                                            className="icon-btn"
                                            title={t.edit}
                                            style={{ ...iconBtnStyle, flex: 1, width: "auto", gap: 6 }}
                                        >
                                            <Icon name="edit" size={12} color="#94A3B8" />
                                            <span style={{ fontSize: 11, color: "#64748B" }}>{t.edit}</span>
                                        </button>

                                        <button
                                            onClick={() => requestDeactivate(employee)}
                                            className="deact-btn"
                                            title={isActive ? t.deactivate : t.activate}
                                            style={{
                                                flex: 1,
                                                height: 26,
                                                borderRadius: 7,
                                                border: `0.5px solid ${isActive ? "#FEE2E2" : "#DCFCE7"}`,
                                                background: isActive ? "#FEF2F2" : "#ECFDF5",
                                                cursor: "pointer",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                gap: 6,
                                            }}
                                        >
                                            <Icon
                                                name={isActive ? "user-off" : "user-check"}
                                                size={12}
                                                color={isActive ? "#DC2626" : "#059669"}
                                            />
                                            <span style={{ fontSize: 11, color: isActive ? "#DC2626" : "#059669" }}>
                                                {isActive ? t.deactivate : t.activate}
                                            </span>
                                        </button>

                                        <button
                                            onClick={() => handleOpenUserModal(employee)}
                                            className="icon-btn"
                                            title={t.createUser}
                                            style={{ ...iconBtnStyle, flex: 1, width: "auto", gap: 6 }}
                                        >
                                            <Icon name="user-plus" size={12} color="#94A3B8" />
                                            <span style={{ fontSize: 11, color: "#64748B" }}>{t.createUser}</span>
                                        </button>
                                    </div>
                                </div>
                            );
                        })
                    ) : (
                        // --- Desktop / tablet: grid table (supports flat list or hierarchical tree) ---
                        pagedDisplayRows.map(({ employee, level, hasChildren }, i) => {
                            const name = `${employee.firstName || ""} ${employee.lastName || ""}`.trim() || "—";
                            const phone = employee.phoneNumber || "—";
                            const address = employee.address || "—";
                            const isActive = employee.isActive ?? employee.active ?? true;
                            const isCollapsed = collapsedIds.has(employee.id);
                            const managerName = getManagerName(employee);
                            return (
                                <div
                                    key={employee.id ?? i}
                                    className="employee-row"
                                    style={{
                                        display: "grid",
                                        gridTemplateColumns: cols,
                                        alignItems: "center",
                                        padding: "11px 18px",
                                        borderBottom: i < pagedDisplayRows.length - 1 ? "0.5px solid #F1F5F9" : "none",
                                        background: i % 2 === 1 ? "#EEF1F7" : "#fff",
                                        transition: "background .12s",
                                        gap: 10,
                                    }}
                                >
                                    <div style={{ display: "flex", alignItems: "center", gap: 8, marginInlineStart: viewMode === "tree" ? level * 18 : 0, minWidth: 0 }}>
                                        {viewMode === "tree" && (
                                            hasChildren ? (
                                                <button
                                                    onClick={() => toggleCollapse(employee.id)}
                                                    style={{
                                                        width: 16,
                                                        height: 16,
                                                        border: "none",
                                                        background: "none",
                                                        cursor: "pointer",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        flexShrink: 0,
                                                        padding: 0,
                                                    }}
                                                >
                                                    <Icon
                                                        name="chevron"
                                                        size={11}
                                                        color="#64748B"
                                                        style={{ transform: isCollapsed ? "rotate(-90deg)" : "rotate(0)", transition: "transform .12s" }}
                                                    />
                                                </button>
                                            ) : (
                                                <span style={{ width: 16, flexShrink: 0 }} />
                                            )
                                        )}
                                        <Avatar name={name} index={i} />
                                        <div style={{ minWidth: 0 }}>
                                            <p style={{ fontSize: 12, fontWeight: 500, color: "#0F172A", margin: 0 }}>{name}</p>
                                        </div>
                                    </div>
                                    <p style={{ fontSize: 11, color: "#6C3DFF", margin: 0 }}>{employee.postName || "—"}</p>
                                    <p style={{ fontSize: 11, color: "#475569", margin: 0 }}>{managerName}</p>
                                    <p style={{ fontSize: 11, color: "#475569", margin: 0 }}>{phone}</p>
                                    <p style={{ fontSize: 11, color: "#475569", margin: 0 }}>{address}</p>
                                    <p style={{ fontSize: 11, color: "#475569", margin: 0, textAlign: "center" }}>
                                        {employeeRoles[employee.id] || "—"}
                                    </p>
                                    <div style={{ textAlign: "center" }}>
                                        <StatusPill active={isActive} t={t} />
                                    </div>
                                    <div style={{ display: "flex", gap: 5, justifyContent: "center" }}>
                                        <button onClick={() => handleEdit(employee)} className="icon-btn" title={t.edit} style={iconBtnStyle}>
                                            <Icon name="edit" size={12} color="#94A3B8" />
                                        </button>

                                        <button
                                            onClick={() => requestDeactivate(employee)}
                                            className="deact-btn"
                                            title={isActive ? t.deactivate : t.activate}
                                            style={{
                                                width: 26,
                                                height: 26,
                                                borderRadius: 7,
                                                border: `0.5px solid ${isActive ? "#FEE2E2" : "#DCFCE7"}`,
                                                background: isActive ? "#FEF2F2" : "#ECFDF5",
                                                cursor: "pointer",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                transition: "all .12s",
                                            }}
                                        >
                                            <Icon
                                                name={isActive ? "user-off" : "user-check"}
                                                size={12}
                                                color={isActive ? "#DC2626" : "#059669"}
                                            />
                                        </button>

                                        <button
                                            onClick={() => handleOpenUserModal(employee)}
                                            className="icon-btn"
                                            title={t.createUser}
                                            style={iconBtnStyle}
                                        >
                                            <Icon name="user-plus" size={12} color="#94A3B8" />
                                        </button>
                                    </div>
                                </div>
                            );
                        })
                    )}
                    </div>

                    {viewMode === "list" && !loading && !error && totalItems > 0 && (
                        <PaginationBar
                            page={page}
                            totalPages={totalPages}
                            pageSize={pageSize}
                            onPageChange={setPage}
                            onPageSizeChange={setPageSize}
                            rangeStart={pageRangeStart}
                            rangeEnd={pageRangeEnd}
                            total={totalItems}
                            t={t}
                        />
                    )}
                </div>

                {!loading && !error && (
                    <p style={{ fontSize: 10, color: "#94A3B8", marginTop: 11, textAlign: "left" }}>
                        {filtered.length} {t.of} {employees.length} {t.employeeCountLabel}
                    </p>
                )}
            </div>

            <Modal
                open={modalOpen}
                onClose={() => { setModalOpen(false); setEditEmployee(null); }}
                title={editEmployee ? t.editEmployee : t.addNewEmployee}
                sub={editEmployee ? `${t.idLabel}: ${editEmployee.id}` : t.enterEmployeeInfo}
                onSave={handleSave}
                loading={saving}
                initialData={editEmployee}
                t={t}
                postOptions={posts}
                postsLoading={postsLoading}
                parentOptions={employees}
            />

            <UserModal
                open={userModalOpen}
                onClose={() => { setUserModalOpen(false); setUserModalEmployee(null); }}
                employee={userModalEmployee}
                onSave={handleSaveUser}
                loading={savingUser}
                t={t}
            />

            {confirmDeactivate && (
                <div style={{ position: "fixed", inset: 0, background: "rgba(15,23,42,.45)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1600, padding: 16 }}>
                    <div style={{ background: "#fff", borderRadius: 18, width: "min(360px, 100%)", boxShadow: "0 20px 60px rgba(15,23,42,.25)", padding: 22 }}>
                        <h3 style={{ margin: 0, fontSize: 14, fontWeight: 700, color: "#1E293B" }}>{t.confirmStatusTitle}</h3>
                        <p style={{ margin: "10px 0 0", fontSize: 12, color: "#64748B", lineHeight: 1.7 }}>
                            {confirmDeactivate.isActive
                                ? t.confirmDeactivateMessage(`${confirmDeactivate.firstName || ""} ${confirmDeactivate.lastName || ""}`.trim())
                                : t.confirmActivateMessage(`${confirmDeactivate.firstName || ""} ${confirmDeactivate.lastName || ""}`.trim())}
                        </p>
                        <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 20 }}>
                            <button
                                onClick={closeConfirmDeactivate}
                                style={{
                                    height: 38, padding: "0 16px", borderRadius: 10, border: "1.5px solid #E8ECF4",
                                    background: "#fff", color: "#475569", fontSize: 11.5, fontWeight: 600,
                                    fontFamily: FONT, cursor: "pointer",
                                }}
                            >
                                {t.cancel}
                            </button>
                            <button
                                onClick={confirmDeactivateStatus}
                                style={{
                                    height: 38, padding: "0 20px", borderRadius: 10, border: "none",
                                    background: confirmDeactivate.isActive ? "#EF4444" : "#10B981", color: "#fff",
                                    fontSize: 11.5, fontWeight: 700, fontFamily: FONT, cursor: "pointer",
                                }}
                            >
                                {t.confirmYes}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <Toast message={toast.message} visible={toast.visible} />
        </div>
    );
}